import { EBuildersProjectsLocationsActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setBuildersProjectsLocations = actionGenerator<EBuildersProjectsLocationsActionTypes.SetData, number[]>(
  EBuildersProjectsLocationsActionTypes.SetData,
);
